
import { AuthContext } from "@contexts/AuthContext";
import AuthRoutes from "@routes/auth.routes";
import { useContext, useEffect } from "react";
import "./App.css";
import Master from "./pages/Master";
import { BrowserRouter } from "react-router-dom";
import { ServiceBase } from "@services/ServiceBase";
import useStorage from "@hooks/useStore";

function App() {
  const { token } = useContext(AuthContext);
  const [t, setToken] = useStorage<string>(`token`);

  
    ServiceBase.instance.defaults.headers["Authorization"] = "bearer " + t;


  return <div className="App">
    <BrowserRouter>

      {token ? <Master /> : <AuthRoutes/>}
    </BrowserRouter>
  </div>;
}

export default App;
